// Centralised RBAC matrix for the admin frontend.
// Keep in sync with /app/backend/routes/admin.py (require_roles deps).

export const ROLES = Object.freeze({
  GERAL: "geral",
  MASTER: "master",
  FINANCEIRO: "financeiro",
  BILHETEIRA: "bilheteira",
});

// Page-level permission map. Keys must match the route/sidebar `id`s.
// Each value is the list of roles allowed to SEE that page.
const PAGE_ACCESS = {
  dashboard:     ["geral", "master", "financeiro", "bilheteira"],
  tickets:       ["geral", "master", "bilheteira"],
  plans:         ["geral", "master", "bilheteira"],
  buyers:        ["geral", "master", "bilheteira"],
  users:         ["geral", "master", "bilheteira"],
  checkins:      ["geral", "master", "bilheteira"],
  finance:       ["geral", "master", "financeiro"],
  communication: ["geral", "master", "bilheteira"],
  settings:      ["geral", "master"],                                  // requires elevation too
  admins:        ["geral", "master"],      // gated by re-auth in UI
};

export const canAccess = (role, pageId) => {
  if (!role) return false;
  const allowed = PAGE_ACCESS[pageId];
  if (!allowed) return false;
  return allowed.includes(role);
};

export const isMasterLevel = (role) => role === "geral" || role === "master";

export const ROLE_LABELS = {
  geral: "Geral",
  master: "Master",
  financeiro: "Financeiro",
  bilheteira: "Bilheteira",
};
